<script setup>
import {useMetrics} from "@/composables/use.metrics";
import {getEventSource} from "@/helpers/getEventSource";
import {errorHandler} from "@/lib/errorHandler";
import {targetActionsMap} from "@/lib/sendYmParams";
import {fetchCurrentEvent} from '@/store/calendar/serverInterationMethods.js';
import dayjs from "dayjs";
import "swiper/css";
import "swiper/css/navigation";
import {Navigation} from "swiper/modules";
import {Swiper, SwiperSlide} from "swiper/vue";
import {computed, onBeforeUnmount, onMounted, ref} from "vue";
import {useRouter} from "vue-router";
import {useStore} from "vuex";


const TZ = "Europe/Moscow";

const swiperConfig = {
  spaceBetween: 20,
  slidesPerView: 1,
  modules: [Navigation],
  loop: true,
  freeMode: true,
  grabCursor: true,
  navigation: {
    nextEl: ".dates-button-next",
    prevEl: ".dates-button-prev",
  },
}


const {getters, dispatch} = useStore();

const time = ref(dayjs().tz(TZ));
const interval = ref(null);

const {hit, hitType, getMetricsEventType} = useMetrics();


onMounted(() => {
  getMyEvent(slots.value);
  interval.value = setInterval(() => {
    time.value = dayjs().tz(TZ);
  }, 1000);
});

onBeforeUnmount(() => {
  if (interval.value) {
    clearInterval(interval.value);
  }
});

const slots = computed(() =>
    getters.userData?.slots?.filter(({slot}) => {
      if (slot?.endTime) {
        const endTime = dayjs(slot.endTime).tz(TZ);
        endTime.set('minutes', endTime.get('minutes') - 5);
        const currentTime = time.value;
        if (currentTime.isBefore(endTime)) {
          return slot;
        }
      }
    })
);

const myEvents = ref([]);

async function getMyEvent(slots) {

  const events = await Promise.all(slots.map(({slot}) => {
    return fetchCurrentEvent(getters.userToken, slot.eventSlots.eventId);
  }));

  if (events.length) {
    myEvents.value = [...events.flatMap(({data}) => data, Infinity)]
  }
}

function getTime(index) {
  const date = dayjs(slots.value[index]?.slot.startTime)
      .tz(TZ)?.format("DD.MM.YYYY")
  const time = dayjs(slots.value[index]?.slot.startTime)
      .tz(TZ)?.format("HH:mm");

  return `${date} | ${time}`;
}

const router = useRouter();


function goToLobby(id, index) {
  const date = dayjs(slots.value[index].slot.startTime)
      .tz(TZ)?.format("DD.MM.YYYY")
  const time = dayjs(slots.value[index].slot.startTime)
      .tz(TZ)?.format("HH:mm");

  targetActionsMap.get(35)(myEvents.value[index].title, date, time, 'Начать');


  if (!slots.value[index]) {
    return false
  }

  const {slot} = slots.value[index];
  const metricsEventType = getMetricsEventType(myEvents.value[index]);
  if (metricsEventType) {
    hit(metricsEventType, hitType.SELECT_EVENT, myEvents.value[index]);
  }

  const query = myEvents.value[index].eventPlace?.length
      ? {place: myEvents.value[index].eventPlace}
      : {};

  router.push({name: 'lobbyPage', params: {id, slotId: slot.id}, query})
}


async function onUnsubscribe(index) {
  const date = dayjs(slots.value[index].slot.startTime)
      .tz(TZ)?.format("DD.MM.YYYY")
  const time = dayjs(slots.value[index].slot.startTime)
      .tz(TZ)?.format("HH:mm");
  targetActionsMap.get(35)(myEvents.value[index].title, date, time, 'Отписаться');
  sessionStorage.removeItem('mapPath');
  if (!slots.value[index]) {
    return;
  }

  const metricsEventType = getMetricsEventType(myEvents.value[index]);
  if (metricsEventType) {
    await hit(metricsEventType, hitType.UNSUBSCRIBE_EVENT, myEvents.value[index]);
  }

  await dispatch("slotEventUnsubscribe", slots.value[index]);
  await dispatch("fetchUserData")
  await getMyEvent(slots.value);

  errorHandler({type: 'success'});

  sessionStorage.removeItem('currentSlot');
}


function onShowUnsubscribeButton(index) {
  if (!slots.value[index]) {
    return false
  }

  const {slot} = slots.value[index];

  const currentTime = time.value;
  const startTime = dayjs(slot.startTime).tz(TZ)

  return startTime.isAfter(currentTime);
}
</script>

<template>
  <section v-if="myEvents.length" class="excursion purple-bg">
    <Swiper v-bind="swiperConfig" class="excursion-filling container">
      <SwiperSlide v-for="(event, index) in myEvents" :key="event.id" class="excursion-content">
        <div class="excursion-info">
          <p class="excursion-info__text">Вы записаны</p>
          <p class="excursion-info__title">{{ event?.title }}</p>
          <div class="excursion-time">
            <div class="excursion-time__element">
              <p class="excursion-time__text">Дата начала</p>
              <p class="excursion-time__title">
                {{ getTime(index) }}
              </p>
            </div>
          </div>
          <!--<p class="excursion-mobile__info">
            Вы можете пройти экскурсию только с персонального компьютера.
          </p>-->
          <div class="excursion-control">
            <button v-if="event?.id" class="link link--small" @click="goToLobby(event?.id, index)">Начать
              <img src="@/assets/new-icons/ArrowRight.svg" alt="Перейти" class="link__icon"/>
            </button>
            <button v-if="onShowUnsubscribeButton(index)" class="link  link--red" @click.stop="onUnsubscribe(index)">
              Отписаться
            </button>
          </div>
        </div>
        <div class="excursion-prevue">
          <div class="excursion-img">
            <img v-if="event?.title === 'Хроники Победы'" src="@/assets/chronicles-bg.png" alt=""
                 class="excursion-img__content"/>
            <img v-else :src="getEventSource(event)" alt="" class="excursion-img__content"/>
          </div>
        </div>
      </SwiperSlide>
      <div v-if="myEvents.length > 1" class="dates-button-wrapper">
        <button class="dates-button dates-button-next">
          <img src="@/assets/new-icons/dates-arrow.svg"/>
        </button>
        <button class="dates-button dates-button-prev">
          <img src="@/assets/new-icons/dates-arrow.svg"/>
        </button>
      </div>
    </Swiper>

  </section>
</template>

<style scoped lang="scss">
.excursion {
  margin-top: 1rem;
  padding: 3.75rem 0;


  .dates-button {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    z-index: 1;
    left: -10px;
    display: flex;

    @media (max-width: 768px) {
      left: 0;
    }

    &-next {
      right: -10px;
      transform: translateY(-50%) rotate(180deg);
      left: unset;

      @media (max-width: 768px) {
        right: 0;
      }
    }
  }

  &-mobile__info {
    display: none;

    @media (max-width: 767px) {
      display: block;
      margin-top: 0.8rem;
      font-size: 1rem;
      font-weight: 500;
      color: #D72D41;
    }
  }

  &-content {
    display: flex;
    align-items: center;
    padding: 2.5rem;
    gap: 2rem;
    background: #ffffff;
    border-radius: 2rem;
    justify-content: space-between;
  }

  &-control {
    margin-top: 3rem;
    display: flex;
    align-items: center;
    gap: 1rem;

    @media (max-width: 767px) {
      flex-direction: column;
      margin-top: 1.5rem;
    }
  }

  &-info {
    max-width: 100%;
    width: 100%;

    &__text {
      font-size: 1rem;
      line-height: 140%;
      color: #919191;
    }

    &__title {
      font-weight: 500;
      font-size: 3.5rem;
      line-height: 120%;
      word-break: break-word;
    }


    .link {
      font-size: 1.125rem;
      padding: 1rem 1.5rem;
      line-height: 133%;

      &--blue {
        background: #00288c;
      }

      &--small {
        padding: 0.75rem 1.25rem;
      }

    }
  }

  &-time {
    margin-top: 1.75rem;
    display: flex;
    flex-wrap: wrap;
    gap: 2.75rem;

    &__text {
      font-size: 1rem;
      line-height: 140%;
      color: #919191;
    }

    &__title {
      margin-top: 0.5rem;
      font-size: 2rem;
      line-height: 130%;
      letter-spacing: 0.01em;
    }
  }

  &-prevue {
    max-width: 40rem;
    width: 100%;
  }

  &-img {
    position: relative;
    width: 100%;
    padding-bottom: 56.25%;
    border-radius: 1.75rem;

    &__content {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      border-radius: 1.75rem;
      object-fit: cover;
    }
  }

  @media (max-width: 1100px) {
    padding: 2rem 0;

    &-content {
      flex-direction: column-reverse;
      align-items: unset;
      padding: 1rem;
      gap: 1rem;
      background: #ffffff;
    }

    &-info {
      &__title {
        font-size: 1.5rem;
        line-height: 130%;
      }

      .link {
        padding: 0.8125rem;
        max-width: 100%;
        width: 100%;
        justify-content: center;
        font-size: 1rem;
        border-radius: 12.5rem;

        /*@media (max-width: 767px) {
          &:not(&--red) {
            display: none;
          }
        }*/

        &__icon {
          @media (max-width: 767px) {
            display: none;
          }
        }
      }
    }

    &-time {
      margin-top: 1rem;

      &__text {
        font-size: 1rem;
        line-height: 140%;
        color: #919191;
      }

      &__title {
        margin-top: 0.5rem;
        font-size: 1.25rem;
      }
    }

    &-prevue {
      max-width: 40rem;
      width: 100%;
    }

    &-img {
      position: relative;
      width: 100%;
      padding-bottom: 56.25%;
      border-radius: 1.75rem;

      &__content {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        border-radius: 1.75rem;
        object-fit: cover;
      }
    }
  }
}
</style>
